import {IHttpResponse, IHttpService} from "angular";
import {SmsSettings, UserSettings} from "modules/user_settings/model/UserSettings";
import {getAbsoluteUrl} from "modules/utils/urlUtill";
import {OpportunitySetting} from "modules/user_settings/model/enums/enums";
import _ = require("lodash");
import {PreviewResponse} from "modules/user_settings/model/PreviewResponse";

export const UserSettingsServiceName = 'UserSettingsService';

export class UserSettingsService {

    static instance = [
        '$http',
        UserSettingsService
    ]

    constructor(private $http: IHttpService) {
    }

    saveSettings(settings: UserSettings) {
        return this.$http.post(getAbsoluteUrl('api/user-settings'), settings);
    }

    saveSmsSettings(settings: SmsSettings) {
        return this.$http.post(getAbsoluteUrl('api/user-sms-settings'), settings);
    }

    renderPreview(settings: UserSettings, opportunity: OpportunitySetting) {
        const url = `api/render-preview?opportunity=${opportunity}`;
        return this.$http.post(getAbsoluteUrl(url), settings);
    }

    fetchSignature() {
        return this.$http.get(getAbsoluteUrl('api/signature'));
    }

    cloneSettings(settings: any): UserSettings {
        return {...settings};
    }

    settingsChanged(original: any, updated: any): boolean {
        return !_.isEqual(original, updated);
    }

    renderPreviewCall(updatedSettings: UserSettings, opportunity: string, callback: (response: IHttpResponse<PreviewResponse>) => void, finallyCalback : () => void) { //need to replace
        this.$http({
            method: 'POST',
            url: getAbsoluteUrl(`api/render-preview?opportunity=${opportunity}`),
            data: updatedSettings
        }).then(callback).catch((error) => {
            console.error("Error rendering preview", error);
        }).finally(finallyCalback);
    }

    renderSmsPreviewCall(updatedSettings: SmsSettings, opportunity: string, callback: (response: IHttpResponse<PreviewResponse>) => void, finallyCalback : () => void) { //need to replace
        this.$http({
            method: 'POST',
            url: getAbsoluteUrl(`api/render-sms-preview?opportunity=${opportunity}`),
            data: updatedSettings
        }).then(callback).catch((error) => {
            console.error("Error rendering preview", error);
        }).finally(finallyCalback);
    }
}
